import { Helmet } from "react-helmet-async";

const SITE_URL = "https://www.shuletaki.com.tr";
const DEFAULT_DESCRIPTION = "Shule Tasarım Aksesuar: kolye, küpe, yüzük, bileklik, saç aksesuarı ve hediye seçkileri. Her Anında Sen.";
const BRAND_SAME_AS = ["https://www.instagram.com/shuletaki/","https://www.facebook.com/shuletaki/"];

export function Seo({ title, description, jsonLd, path = "/", noindex = false, image = "/assets/img/logo.png", type = "website" }) {
  const fullTitle = title ? `${title} | Shule` : "Shule Tasarım Aksesuar | Her Anında Sen";
  const metaDescription = description || DEFAULT_DESCRIPTION;
  const canonicalPath = path.startsWith("/") ? path : `/${path}`;
  const canonical = `${SITE_URL}${canonicalPath === "/" ? "/" : canonicalPath}`;
  const socialImage = image.startsWith("http") ? image : `${SITE_URL}${image}`;

  return (
    <Helmet>
      <html lang="tr" />
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta name="robots" content={noindex ? "noindex,nofollow" : "index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1"} />
      <link rel="canonical" href={canonical} />
      <meta property="og:locale" content="tr_TR" />
      <meta property="og:site_name" content="Shule" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={socialImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={socialImage} />
      <meta name="author" content="Shule Tasarım Aksesuar" />
      <meta name="theme-color" content="#F7F1EB" />
      <script type="application/ld+json">{JSON.stringify({"@context":"https://schema.org","@type":"OnlineStore",name:"Shule Tasarım Aksesuar",url:SITE_URL,logo:`${SITE_URL}/assets/img/logo.png`,sameAs:BRAND_SAME_AS})}</script>
      {(Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : []).map((schema, index) => (
        <script key={index} type="application/ld+json">{JSON.stringify(schema)}</script>
      ))}
    </Helmet>
  );
}
